<span class="asset-type-badge" [ngClass]="assetTypeClass">
  {{ label ?? assetType ?? "/" }}
</span>
